/** Ensure rendered geojson carries the gl-draw feature id in properties. */
export function ensureGeoJsonPropertyId(geojson: {
  id?: string | number;
  properties?: Record<string, unknown>;
}): string | null {
  const props = geojson?.properties ?? {};
  const candidates = [props.id, props.__tempFeatureId, props.__mapSketchId, geojson?.id];
  for (const raw of candidates) {
    if (raw == null) continue;
    const id = String(raw).trim();
    if (id && id !== 'undefined') {
      geojson.properties = { ...props, id };
      return id;
    }
  }
  return null;
}

/** Resolve a gl-draw feature id from a map click target or rendered geojson. */
export function resolveDrawFeatureIdFromClick(
  ctx: {
    getFeature?: (id: string) => unknown;
    getAll?: () => { features?: { id?: string | number; toGeoJSON?: () => any }[] };
  },
  e?: { featureTarget?: { id?: string | number; properties?: Record<string, unknown> } },
  geojson?: { id?: string | number; properties?: Record<string, unknown> }
): string | null {
  const props = e?.featureTarget?.properties ?? geojson?.properties ?? {};
  const candidates = [
    props.id,
    props.parent,
    props.__tempFeatureId,
    props.__mapSketchId,
    e?.featureTarget?.id,
    geojson?.id,
  ];

  for (const raw of candidates) {
    if (raw == null) continue;
    const id = String(raw).trim();
    if (!id || id === 'undefined') continue;
    if (ctx.getFeature?.(id)) return id;
  }

  try {
    const all = ctx.getAll?.()?.features ?? [];
    if (all.length === 1 && all[0]?.id != null) {
      const only = String(all[0].id);
      if (ctx.getFeature?.(only)) return only;
    }
  } catch {
    /* ignore */
  }

  return null;
}
